var map = {
	"./spa1-data-injest": [
		195,
		195
	],
	"./spa1-data-injest.json": [
		195,
		195
	],
	"./spa1-data-injest2": [
		411,
		411
	],
	"./spa1-data-injest2.json": [
		411,
		411
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 756;
module.exports = webpackAsyncContext;